const delay = ({ ms }: { ms: number }) => {
  if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'live') {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  return Promise.resolve(); // No delay in other environments
};

export default delay;
